import { useMutation } from '@tanstack/react-query';
import { environment } from '../config/environment';
import type { Form } from '../interfaces/form.interface';

interface RejectWalletData {
  metadata: Record<string, string | boolean | number | string[]>;
  configuration: Form;
}

export const useRejectWallet = (walletId: string) => {
  return useMutation({
    mutationFn: async (data: RejectWalletData) => {
      const response = await fetch(`${environment.API}/wallets/${walletId}/confirmations/rejections`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Failed to reject wallet');
      }

      return response.json();
    },
  });
};
